// reach_ui/src/actions/customForm/index.js
import ActionType from '../ActionType'
import { create, update } from 'actions/data'
import { omit } from 'lodash'

export const addOrUpdateCustomForm = (id) => (dispatch, getState) => {
	const addOrEdit = getState().signupForm.addOrEdit
	const addOrEditCustom = getState().customForm.addOrEdit

	const body = {
    name: addOrEdit.values.formName.value,
    // title: {
    // 	color: addOrEdit.values.titleTextColor.value,
    // 	text: addOrEdit.values.title.value,
    // },
    // description: {
    // 	color: addOrEdit.values.descriptionTextColor.value,
    // 	text: addOrEdit.values.description.value,
    // },
    display_type: addOrEdit.values.embedType.value,
    landing_page: addOrEditCustom.landing_page,
    form: {
      sections: addOrEditCustom.form.sections
        .map(sectionID => omit(addOrEditCustom.sectionsByID[sectionID], 'id'))
        .filter(section => section.type !== 'blank'),
    },
    contactgroup_ids: addOrEdit.groupSelect.value.map(
      groupOption => groupOption.groupID,
    ),
    submit_button: {
      text: addOrEdit.values.buttonText.value,
      text_color: addOrEdit.values.buttonTextColor.value,
      background_color: addOrEdit.values.buttonBackgroundColor.value,
    },
    background_color: addOrEdit.values.backgroundColor.value,
    text_color: addOrEdit.values.textColor.value,
    font: addOrEdit.values.font.value,
  }

	if (addOrEdit.values.logoURL.value) {
		body.logo_url = addOrEdit.values.logoURL.value
	}

	if (addOrEditCustom.internal_type) {
		body.internal_type = addOrEdit.internal_type
	}

	if (addOrEdit.values.title.value) {
		body.title = {
			color: addOrEdit.values.titleTextColor.value,
			text: addOrEdit.values.title.value,
		}
	}

	if (addOrEdit.values.description.value) {
		body.description = {
			color: addOrEdit.values.descriptionTextColor.value,
			text: addOrEdit.values.description.value,
		}
	}

	if (addOrEdit.customLandingPage) {
		body.landing_page = {
			content: {
				HtmlPart: addOrEdit.values.landingPageContent.value,
			},
		}
	} else {
		body.landing_page = {
			url: addOrEdit.values.landingPageURL.value,
		}
	}

	return Promise.resolve(
    dispatch(
      id === 'new'
        ? create(
            {
              entity: body,
              entityType: 'customform',
            } /* , { value: 'customform' } */,
          )
        : update({ ...body, id }, 'customform', null, {
            value: 'customform/formId',
          }),
    ),
  )
}

export const createCustomIntegration = () => (dispatch, getState) => {
	return dispatch(
    create({
      entity: { name: getState().signupForm.addOrEdit.values.formName.value },
      entityType: 'customform',
      path: 'customform/integration',
      hasSchema: false,
    }),
  )
}

export const updateCustomIntegration = (id) => (dispatch, getState) => {
	return dispatch(
		update(
			{ name: getState().signupForm.addOrEdit.values.formName.value },
			'customform',
			`/integration/${id}`,
		),
	)
}

export const toggleView = () => (dispatch) =>
	dispatch({ type: ActionType.CustomForm.TOGGLE_VIEW })

export const toggleSortMenu = (payload) => (dispatch) =>
	dispatch({ type: ActionType.CustomForm.TOGGLE_SORT_MENU })

export const toggleExpandPanel = (payload) => (dispatch) =>
	dispatch({ type: ActionType.CustomForm.TOGGLE_EXPAND_PANEL, payload })

export const changeSort = (payload) => (dispatch) =>
	dispatch({ type: ActionType.CustomForm.CHANGE_SORT, payload })
